import React from 'react';
import {Routes,Route} from 'react-router-dom';
import {Account,Login,ForgotPassword,ResetPassword, Application} from './pages';
import {Dashboard,Approvals,
  Transactions,Overview,Settings,TransInduction,Report,Candidates,PublishResults
} from './pages';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Account />}>
            <Route index element={<Login/>} />
            <Route path="login/*" element={<Login/>} />
            <Route path='forgot-password' element={<ForgotPassword />}/>
            <Route path="change-password/*" element={<ResetPassword />} />
        </Route>        
        <Route path="/" element={<Dashboard/>} >
          <Route index element={<Overview />}/>
          <Route path="approvals/*" element={<Approvals/>}/>
          <Route path="transactions/*" element={<Transactions/>}/>
          <Route path="overview/*" element={<Overview/>}/>
          <Route path="settings/*" element={<Settings/>}/>
          <Route path="induction/*" element={<TransInduction/>}/>
          <Route path="reports/*" element={<Report/>}/>
          <Route path="candidates/*" element={<Candidates/>}/>
          <Route path="application/*" element={<Application/>}/>
          <Route path="/publish-results/*" element={<PublishResults />} />
        </Route>
      </Routes>


    </>
  );
}

export default App;
